// WARNING: This file cannot import anything from the codebase
// It must stay as standalone as possible to prevent loading a tree of dependencies
// from the microsite, causing the build to behave erractically on setup
import { writable, type Writable } from "svelte/store";

export type EnvironmentStore = {
  getFoojiDomain: () => string;
  getBugsnagApiKey: () => string;
  getBusgnagStage: () => string;
  getFoojiMicrositeDomain: () => string;
};

export const setEnvironment = (provider: EnvironmentStore) => {
  environmentStore.set(provider);
};

export const resetEnvironment = (store: Writable<EnvironmentStore> = environmentStore) => {
  // These are defaults for the public library. They get replaced via main > setup() when running the microsite.
  store.set({
    getFoojiDomain: () => window.FoojiDevConfig?.FOOJI_DOMAIN ?? "prod.fooji.com",
    getBugsnagApiKey: () => "88ff4073d7d47838b19a5fe8b190b59a", // custom microsites bugsnag api key
    getBusgnagStage: () => window.FoojiDevConfig ? "development" : "production",
    getFoojiMicrositeDomain: () => window.FoojiDevConfig?.FOOJI_MICROSITE_DOMAIN ?? document.location.host
  });
};

export function initStore() {
  const store = writable<EnvironmentStore>();
  resetEnvironment(store);
  return store;
}

export const environmentStore = initStore();
